"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIssueFormAttributesFromTemplate = exports.getIssueAttributesFromTemplateIssueAttributes = exports.getIssueAttributesFromTemplate = void 0;
var _sdk = require("../../../sdk");
var _dateUtils = require("../../utils/data/dateUtils");
var _pick = _interopRequireDefault(require("lodash/pick"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getIssueAttributesFromTemplateIssueAttributes = templateIssueAttributes => {
  const keysInCommon = ["title", "description", "status", "rootCauseId", "locationId", "locationDetails", "assignedToType", "watchers", "customAttributes"];
  const issueAttributesInCommon = (0, _pick.default)(templateIssueAttributes, keysInCommon);
  const issueAttributes = {
    // title will always be provided, so just use an empty string to make ts happy
    title: "",
    // custom attributes should be provided, but we want an empty object if not
    customAttributes: [],
    // default to Open if no status provided
    status: _sdk.IssueStatus.Open,
    issueTypeId: templateIssueAttributes.typeId,
    published: true,
    ...issueAttributesInCommon
  };
  if (templateIssueAttributes.assigneeId) {
    issueAttributes.assignedTo = templateIssueAttributes.assigneeId;
  }
  if (Number.isInteger(templateIssueAttributes.daysTilDueDate)) {
    issueAttributes.dueDate = (0, _dateUtils.getDateFormatToDays)(new Date(new Date().getTime() + 1000 /* ms */ * 60 /* s */ * 60 /* min */ * 24 /* hr */ * templateIssueAttributes.daysTilDueDate));
  }
  return issueAttributes;
};
exports.getIssueAttributesFromTemplateIssueAttributes = getIssueAttributesFromTemplateIssueAttributes;
const getIssueAttributesFromTemplate = issueTemplate => {
  return getIssueAttributesFromTemplateIssueAttributes(issueTemplate.issueAttributes);
};
exports.getIssueAttributesFromTemplate = getIssueAttributesFromTemplate;
const getIssueFormAttributesFromTemplate = issueTemplate => {
  var _issueAttributes$cust;
  const issueAttributes = getIssueAttributesFromTemplate(issueTemplate);
  const customAttributes = {};
  if ((_issueAttributes$cust = issueAttributes.customAttributes) !== null && _issueAttributes$cust !== void 0 && _issueAttributes$cust.length) {
    issueAttributes.customAttributes.forEach(customAttr => {
      customAttributes[customAttr.attributeDefinitionId] = customAttr.value;
    });
  }
  const issueFormAttributes = {
    ...issueAttributes,
    customAttributes
  };
  return issueFormAttributes;
};
exports.getIssueFormAttributesFromTemplate = getIssueFormAttributesFromTemplate;
//# sourceMappingURL=getIssueAttributesFromTemplate.js.map